import { render } from "./NavbarSide.vue?vue&type=template&id=18d0f6c0&scoped=true"
import script from "./NavbarSide.vue?vue&type=script&lang=js"
export * from "./NavbarSide.vue?vue&type=script&lang=js"

import "./NavbarSide.vue?vue&type=style&index=0&id=18d0f6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d0f6c0"]])

export default __exports__